<template>
	<div id="home" element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- login dialog -->
			<!-- title="请填写个人信息，用于生成实验报告" -->
		<el-dialog
			:visible.sync="loginDialog"
			width="50%"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
		>
			<el-row justify="center">
				<img :src="title" height="60px"/>
			</el-row>
			<Login/>
		</el-dialog>

		<el-container>
			<el-header height="140px">
				<img :src="title" height="90px"/>
				<!-- <h1>基于数字孪生的智慧电气信息感知与协调运行虚拟仿真实验系统</h1> -->
				<el-row type="flex" justify="center">
					<el-col :xl="20" :lg="20" :md="22" :sm="24" :xs="24">
						<!-- top-navbar -->
						<el-menu :default-active="activeIndex" mode="horizontal" :router="true">
							<!-- <el-menu-item index="prepare">实验介绍与流程</el-menu-item> -->
							<el-submenu index="prepare">
								<template slot="title">实验介绍与流程</template>
								<el-menu-item index="prepare">实验介绍</el-menu-item>
								<el-menu-item index="prepare3">实验流程</el-menu-item>
								<el-menu-item index="prepare2">预习测试</el-menu-item>
							</el-submenu>
							<el-submenu index="part1">
								<template slot="title">基本系统认知</template>
								<el-menu-item index="part1-1">系统认知实验</el-menu-item>
								<el-menu-item index="part1-2">设备认知实验</el-menu-item>
							</el-submenu>
							<el-menu-item index="part2">可见光信号分析</el-menu-item>
							<!-- <el-submenu index="/graph1">
								<template slot="title">模块2</template>
								<el-menu-item index="2-1">子模块1</el-menu-item>
								<el-menu-item index="2-2">子模块2</el-menu-item>
							</el-submenu> -->
							<el-menu-item index="part3">红外光信号分析</el-menu-item>
							<el-menu-item index="part4">运行调度设计</el-menu-item>
							<el-menu-item index="part5">实验思考与总结</el-menu-item>

							<!-- <el-submenu index="/graph2">
								<template slot="title">模块3</template>
								<el-menu-item index="3-1">子模块1</el-menu-item>
								<el-menu-item index="3-2">子模块2</el-menu-item>
							</el-submenu> -->
							<!-- <el-submenu index="/design">
								<template slot="title">模块4</template>
								<el-menu-item index="4-1">子模块1</el-menu-item>
								<el-menu-item index="4-2">子模块2</el-menu-item>
							</el-submenu> -->
						</el-menu>
						<!-- <div class="line"></div> -->
						


						<!-- <el-divider></el-divider> -->

					</el-col>
				</el-row>
			</el-header>
			<el-main>
				<el-row type="flex" justify="center">
					<el-col :xl="20" :lg="20" :md="22" :sm="24" :xs="24">
						<router-view></router-view>
					</el-col>
				</el-row>
			</el-main>
			<!-- <el-footer>Footer</el-footer> -->
		</el-container>
		<!-- main container -->
		

		<!-- buttom copy rights -->
	</div>
</template>

<script>
import Login from "@/components/Login"
// import Api from "@/components/Api"
import { mapState } from "vuex"
// import Docxtemplater from 'docxtemplater'
// import { saveAs } from 'file-saver'
// import JSZip from 'jszip';
// import JSZipUtils from 'jszip-utils'
import title from "../assets/title.png"

export default {
	components: { Login },
	name: "home",
	data() {
		return {
			loading: true,
			activeIndex: 'prepare',
			title
		}
	},
	computed: {
		// url() {
		// 	return Api.url + "/images/logo.jpg"
		// },
		...mapState([
			"logined", "name", "nickname", "number", 
			"score1", 
			"score2", 
			"score3", 
		]),
		// score() {
		// 	return this.score1 + this.score2 + this.score3 + 10
		// },
		loginDialog() {
			return !this.logined
		}
	},
	methods: {
	},
	mounted() {
		if (localStorage.getItem("activeIndex")) {
			this.activeIndex = localStorage.getItem("activeIndex")
		}
	},
	watch: {
		activeIndex(newval) {
			localStorage.setItem("activeIndex", newval)
		}
	}
}
</script>

<style>
#home {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 10px;
	margin-bottom: 50px;
}
</style>
